// Bill_new.jsx
const Bill_new = () => {
  return (
    <div className="mobile-center-wrapper">
      <div className="space-y-4 mb-16">
        <div className="p-4 sm:p-6 bg-white rounded-xl shadow">
          <h2 className="text-lg sm:text-xl font-bold mb-4">지출 신규 등록</h2>
        </div>
      </div>
    </div>
  );
};

export default Bill_new;
